<template>
  <div class="field">
    <div :class="{ field__warning: showWarning }">
      <slot name="label" />
      <vue-tel-input
        :key="keyName"
        :value="inputValue"
        :class="['field__input', { label: $slots.label, required: isRequired }]"
        :disabled="disabled"
        :placeholder="placeholder"
        mode="national"
        valid-characters-only
        :max-len="20"
        auto-format
        :auto-default-country="false"
        :default-country="country"
        :preferred-countries="preferredCountries"
        @validate="validate"
        @input="onUpdatePhone"
        @country-changed="handleCountry"
      />
    </div>
    <div v-if="showWarning" class="warningGroup">
      <p class="warningGroup__warning">
        {{ $t('shared.validation.phone_number') }}
      </p>
    </div>
  </div>
</template>
<script setup>
import i18n from '@/i18n'
import _ from 'underscore'
import { computed, onMounted, ref } from 'vue'
import { VueTelInput } from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

const $t = i18n.t

const emit = defineEmits(['inputChange', 'validate'])
const props = defineProps({
  id: String,
  type: {
    type: String,
    default: 'phone'
  },
  value: String,
  disabled: Boolean,
  placeholder: String,
  required: {
    type: Boolean,
    default: true
  }
})

const inputValue = ref(props.value)
const isValid = ref(true)
const country = ref(null)
const preferredCountries = ref([
  'dk',
  'se',
  'de',
  'fr',
  'be',
  'gb',
  'es',
  'it',
  'pt'
])
const keyName = ref(0)

const showWarning = computed(() => {
  if (!props.value) return false
  return !isValid.value && inputValue.value.toString().length > 0
})
const isRequired = computed(() => {
  if (!props.required) {
    return false
  } else {
    return inputValue.value === ''
  }
})

onMounted(() => {
  setTimeout(() => {
    if (inputValue.value) {
      inputValue.value = inputValue.value.trim()
    }
    keyName.value += 1
  }, 1000)
})

function onUpdatePhone(_, payload) {
  if (payload) {
    country.value = payload.countryCode
    inputValue.value = payload.formatted
    emit('inputChange', { value: payload.number })
  }
}
const validate = _.debounce(function (payload) {
  const valid = payload.valid === undefined ? true : payload.valid
  isValid.value = valid
  emit('validate', valid)
}, 300)
function handleCountry(country) {
  country.value = country.iso2
}
</script>

<style lang="scss" scoped>
.field {
  display: flex;
  flex-direction: column;
  margin: 0 !important;

  &__input {
    color: #454a5b !important;
    padding: 10px !important;
    width: auto !important;
    border: 1px solid #e6e7ec !important;
    border-radius: var(--border-radius) !important;
    padding: 10px !important;
    font-size: 1rem !important;

    &:hover {
      border: 1px solid #2c3fd5 !important;
    }

    &:focus-within {
      border: 1px solid #0d1fb8 !important;
    }

    &.vue-tel-input {
      padding: 2px !important;
    }
  }
  .required {
    border: 1px solid red !important;
  }

  &:not(:last-child) {
    margin-bottom: 0 !important;
  }
  &:disabled {
    cursor: not-allowed;
    background: var(--background-primary);
  }
  &__warning {
    .field__input {
      outline: none;
      border: 1px solid red !important;
    }
  }
  .warningGroup {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &__warning {
      width: 100%;
      color: red;
      position: relative;
      font-size: 14px;
    }
  }
  :deep() {
    .bf,
    .bi {
      position: unset;
      top: unset;
      bottom: unset;
      -ms-user-select: unset;
      -moz-user-select: unset;
      -webkit-user-select: unset;
      user-select: unset;
    }
  }
}
</style>
